import _implicitStylesheets from "./contentTile.css";
import _implicitScopedStylesheets from "./contentTile.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _adsImage from "ads/image";
import _wdsButton from "wds/button";
import _wdsTile from "wds/tile";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _wdsContentTitle from "wds/contentTitle";
import _wdsContentText from "wds/contentText";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a class="link${0}"${"a0:href"} rel="nofollow"${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div class="description${0}"${2}>${"t1"}</div>`;
const stc0 = {
  "type": "contentTile"
};
const stc1 = {
  "block": true
};
const stc2 = {
  "role": "group"
};
const stc3 = {
  classMap: {
    "image": true
  },
  key: 3
};
const stc4 = {
  slotAssignment: "fallback",
  classMap: {
    "fallback-image": true
  },
  key: 5
};
const stc5 = {
  props: {
    "fill": "#ECECEC",
    "width": "140px",
    "height": "100%",
    "symbol": "image"
  },
  key: 6
};
const stc6 = {
  classMap: {
    "title": true
  },
  attrs: {
    "type-style": "display-7"
  },
  key: 7
};
const stc7 = {
  classMap: {
    "callToAction": true
  },
  key: 14
};
const stc8 = {
  props: {
    "isLoading": "true",
    "variant": "small_rounded",
    "height": "240px",
    "width": "100%"
  },
  key: 16
};
const stc9 = {
  classMap: {
    "title": true
  },
  key: 17
};
const stc10 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "80%"
  },
  key: 18
};
const stc11 = {
  classMap: {
    "description": true
  },
  key: 19
};
const stc12 = {
  props: {
    "isLoading": "true"
  },
  key: 20
};
const stc13 = {
  props: {
    "isLoading": "true"
  },
  key: 21
};
const stc14 = {
  props: {
    "isLoading": "true"
  },
  key: 22
};
const stc15 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "20%"
  },
  key: 23
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [!$cmp.isLoading ? api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("div", {
    classMap: stc1,
    attrs: stc2,
    key: 1,
    on: {
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleKeyPress))
    }
  }, [api_custom_element("wds-tile", _wdsTile, {
    props: {
      "variant": $cmp.variant
    },
    key: 2
  }, [api_element("div", stc3, [$cmp.image ? api_custom_element("ads-image", _adsImage, {
    props: {
      "variant": "small_rounded",
      "height": "240px",
      "width": "100%",
      "src": $cmp.image.url,
      "alt": $cmp.image.altText
    },
    key: 4
  }, [api_element("div", stc4, [api_custom_element("ads-icon", _adsIcon, stc5)])]) : null]), api_element("div", stc6, [$cmp.callToAction ? api_static_fragment($fragment1, 9, [api_static_part(0, {
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleClick))
    },
    attrs: {
      "href": $cmp.callToAction.url
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]) : null, !$cmp.callToAction ? api_static_fragment($fragment2, 11, [api_static_part(1, null, api_dynamic_text($cmp.title))]) : null]), api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text($cmp.description))]), $cmp.callToAction ? api_element("div", stc7, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.callToAction.url,
      "variant": "text",
      "label": $cmp.callToAction.label
    },
    key: 15
  })]) : null])])]) : null, $cmp.isLoading ? api_custom_element("ads-image", _adsImage, stc8) : null, $cmp.isLoading ? api_element("div", stc9, [api_custom_element("wds-content-title", _wdsContentTitle, stc10)]) : null, $cmp.isLoading ? api_element("div", stc11, [api_custom_element("wds-content-text", _wdsContentText, stc12), api_custom_element("wds-content-text", _wdsContentText, stc13), api_custom_element("wds-content-text", _wdsContentText, stc14)]) : null, $cmp.isLoading ? api_custom_element("wds-content-title", _wdsContentTitle, stc15) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2npd52vi7si";
tmpl.legacyStylesheetToken = "undefined-_contentTile";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
